import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'components/ui/Button/Button';
import { useNavigate } from 'react-router-dom';
import { createPortal } from 'react-dom';

interface ExpiredTimeoutProps {
  navigatePath: string;
  onClose: () => void;
}

const ExpiredTimeout: FC<ExpiredTimeoutProps> = ({ navigatePath, onClose }) => {
  const [t] = useTranslation();
  const navigate = useNavigate();

  const onClickHome = () => {
    navigate(navigatePath);
  };

  return createPortal(
    <div className="modal-overlay modal-overlay-top">
      <div className="modal modal-sm active">
        <div className="modal-title">
          <h5 className="title">{t('home.search_out_of_date')}</h5>
        </div>
        <div className="modal-content">
          <p>{t('home.please_refresh')}</p>
        </div>
        <div className="modal-footer">
          <Button
            title={t('home.new_search')}
            className="btn btn-default ml-0"
            onClick={() => onClickHome()}
          />
          <Button
            title={t('home.refresh_results')}
            className="btn btn-primary mr-a"
            onClick={() => window.location.reload()}
          />
          <Button title={t('close')} className="btn btn-default" onClick={() => onClose()} />
        </div>
      </div>
    </div>
    , document.body);
};

export default ExpiredTimeout;

